if (!customElements.get('free-shipping-progress') && typeof FreeShippingProgress === 'undefined') {
	class FreeShippingProgress extends HTMLElement {
		static previousProgress = '0%';
		static previousQualified = false;
		static initial = true;

		static reset() {
			this.previousProgress = '0%';
			this.previousQualified = false;
			this.initial = true;
		}

		connectedCallback() {
			// Set initial state.
			this.style.setProperty('--free-shipping-progress-prev', this.constructor.previousProgress);
			this.dataset.previousQualified = this.constructor.previousQualified;
		}

		disconnectedCallback() {
			this.dataset.loaded = 'false';
			this.constructor.previousProgress = this.progress;
			this.constructor.previousQualified = this.qualified;
		}

		get progress() {
			return this.dataset.progress || '0%';
		}

		set progress(value) {
			this.dataset.progress = value || '0%';
		}

		get qualified() {
			return this.progress === '100%';
		}

		setBarEnd(reset = false) {
			const progress = reset ? '0%' : this.progress;
			const qualified = reset ? false : this.qualified;

			this.style.setProperty('--free-shipping-progress', progress);
			this.dataset.qualified = qualified ? 'true' : 'false';
		}

		async showState() {
			this.dataset.loaded = 'true';
			this.constructor.initial = false;
			this.setBarEnd();
		}
	}

	class FreeShippingProgressBanner extends FreeShippingProgress {
		async connectedCallback() {
			super.connectedCallback();
			await this.showState();
		}

		async showState() {
			const delay = this.constructor.initial;

			// On initial load, wait to ensure the DOM is fully loaded.
			if (delay) await new Promise(resolve => setTimeout(resolve, 0));

			super.showState();
		}
	}

	class FreeShippingProgressDrawer extends FreeShippingProgress {
		connectedCallback() {
			super.connectedCallback();

			this.cartDrawer = this.closest('cart-drawer');
			if (!this.cartDrawer) {
				console.warn('FreeShippingProgressDrawer must be used within a cart-drawer.');
				return;
			}

			if (this.cartDrawer.classList.contains('active')) {
				// If the drawer is already open, show the state immediately.
				this.showState(true);
			}

			this.boundOnDrawerOpen = this.onDrawerOpen.bind(this);
			this.cartDrawer.addEventListener('drawer:open', this.boundOnDrawerOpen);
		}

		disconnectedCallback() {
			super.disconnectedCallback();
			this.cartDrawer.removeEventListener('drawer:open', this.boundOnDrawerOpen);
		}

		async showState(canShowConfetti = false) {
			super.showState();

			if (!canShowConfetti) return;
	
			if (this.qualified && !this.constructor.previousQualified) this.playConfetti();
		}

		async onDrawerOpen(event) {
			const fromAddToCart = event.detail.triggeredBy === 'product-form';

			let delay = 100;

			// If triggered by add to cart, give more time for drawer to settle.
			if (fromAddToCart) delay = 250;

			// Wait for drawer to settle.
			await new Promise(resolve => setTimeout(resolve, delay));
			this.showState(fromAddToCart);
		}

		async playConfetti() {
			if (typeof Confetti !== 'function') {
				console.warn('Confetti function is not defined. Ensure the confetti library is loaded.');
				return;
			}

			if (!FreeShippingProgressDrawer.confetti) {
				FreeShippingProgressDrawer.confetti = new Confetti(this, this);

				// Edit given parameters
				FreeShippingProgressDrawer.confetti.setCount(100);
				FreeShippingProgressDrawer.confetti.setSize(1);
				FreeShippingProgressDrawer.confetti.setPower(7);
				FreeShippingProgressDrawer.confetti.setFade(true);
				FreeShippingProgressDrawer.confetti.destroyTarget(false);
			}

			await new Promise(resolve => setTimeout(resolve, 750)); // Wait for bar or setup to settle.

			FreeShippingProgressDrawer.confetti.playInElement(this);
		}
	}

	customElements.define('free-shipping-progress', FreeShippingProgress);
	customElements.define('free-shipping-progress-banner', FreeShippingProgressBanner);
	customElements.define('free-shipping-progress-drawer', FreeShippingProgressDrawer);

	window.FreeShippingProgress = FreeShippingProgress;
	window.FreeShippingProgressBanner = FreeShippingProgressBanner;
	window.FreeShippingProgressDrawer = FreeShippingProgressDrawer;
}